import { Checkbox, SimpleGrid, Text } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { HeartRhythmMeasurementDiagnosis } from 'models/heartRhythm/measurementDiagnosis';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';

export const ReviewedLabelFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();
  const dataField = 'data.heartRhythmMeasurement.reviewedLabelCondition';

  const labels = [
    // Row 1
    HeartRhythmMeasurementDiagnosis.sinus,
    HeartRhythmMeasurementDiagnosis.extrasystoles_bigminy,
    HeartRhythmMeasurementDiagnosis.extrasystoles_trigeminy,
    HeartRhythmMeasurementDiagnosis.dubious_rhythm,
    // Row 2
    HeartRhythmMeasurementDiagnosis.increased_hrv,
    HeartRhythmMeasurementDiagnosis.extrasystoles_big_episode,
    HeartRhythmMeasurementDiagnosis.extrasystoles_trig_episode,
    HeartRhythmMeasurementDiagnosis.other,
    // Row 3
    HeartRhythmMeasurementDiagnosis.extrasystoles_isolated,
    HeartRhythmMeasurementDiagnosis.tachycardia,
    HeartRhythmMeasurementDiagnosis.bradycardia,
    HeartRhythmMeasurementDiagnosis.atrial_fibrillation,
    // Row 4
    HeartRhythmMeasurementDiagnosis.extrasystoles_frequent,
    HeartRhythmMeasurementDiagnosis.tachy_episode,
    HeartRhythmMeasurementDiagnosis.brady_episode,
    HeartRhythmMeasurementDiagnosis.atrial_flutter,
  ];

  return (
    <AccordionWithSwitch
      title={` ${t('reviewed_label_title')} *`}
      dataField={dataField}
      disabled={values.data.heartRhythmMeasurement.indicatorCondition?.enabled}
    >
      <Text size={'xs'} mb={-5} c={'var(--mantine-color-blue-5)'}>
        {t('reviewed_label_description')}
      </Text>
      <Checkbox.Group
        {...getInputProps(`${dataField}.reviewedLabel`)}
        error={displayFormError({ errors, dataField: `${dataField}.reviewedLabel`, label: t('empty_value_select') })}
      >
        <SimpleGrid cols={4} verticalSpacing={'xs'} mb={'xs'}>
          {Object.values(labels).map((label) => (
            <Checkbox key={label} value={label} label={t(`diagnosis_${label}`)} disabled={values.formDisabled} />
          ))}
        </SimpleGrid>
      </Checkbox.Group>
    </AccordionWithSwitch>
  );
};
